// A small repository-native line-icon vocabulary; decorative beside visible text.
export default function Icon({ name = 'info', ...props }) {
  const paths = {
    info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6m0-10v1" /></>,
    success: <><circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /></>,
    warning: <><path d="m12 3 10 18H2L12 3Zm0 6v5m0 3v1" /></>,
    danger: <><circle cx="12" cy="12" r="9" /><path d="m9 9 6 6m0-6-6 6" /></>,
    clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
    empty: <><path d="M4 8h16v12H4zM8 4h8M8 12h8m-6 4h4" /></>,
  };
  return <svg className="fc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
    {paths[name] || paths.info}
  </svg>;
}
